import {
  fuseConfigurationsConstants,
  testConfigurationsConstants,
} from "../_redux-constants";
import { configurationOptionsService } from "../../_services";

function getFuseConfigurations() {
  function getFuseConfigurationsLoad() {
    return { type: fuseConfigurationsConstants.FUSE_CONFIGURATIONS_LOADING };
  }

  function fuseConfigurationsSuccess(data) {
    return {
      type: fuseConfigurationsConstants.FUSE_CONFIGURATIONS_SUCCESS,
      data,
    };
  }

  function fuseConfigurationsFailure(error) {
    return {
      type: fuseConfigurationsConstants.FUSE_CONFIGURATIONS_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getFuseConfigurationsLoad());
    return configurationOptionsService.getFuseConfigurations().then(
      (data) => {
        dispatch(fuseConfigurationsSuccess(data));
      },
      (error) => {
        dispatch(fuseConfigurationsFailure(error));
      }
    );
  };
}

function getTestConfigurations() {
  function getTestConfigurationsLoad() {
    return { type: testConfigurationsConstants.TEST_CONFIGURATIONS_LOADING };
  }

  function testConfigurationsSuccess(data) {
    return {
      type: testConfigurationsConstants.TEST_CONFIGURATIONS_SUCCESS,
      data,
    };
  }

  function testConfigurationsFailure(error) {
    return {
      type: testConfigurationsConstants.TEST_CONFIGURATIONS_FAILURE,
      error,
    };
  }

  return (dispatch) => {
    dispatch(getTestConfigurationsLoad());
    return configurationOptionsService.getTestConfigurations().then(
      (data) => {
        dispatch(testConfigurationsSuccess(data));
      },
      (error) => {
        dispatch(testConfigurationsFailure(error));
      }
    );
  };
}

export const configurationOptionsActions = {
  getFuseConfigurations,
  getTestConfigurations,
};
